import { useCallback } from 'react';
import { THandleSubmit } from './types';
import { IHandleSubmitParams } from '../types';
import { validateFormInputs } from '../helpers/validateFormInputs';
import { isFunction } from 'lodash';
import { constructSubmitData } from '../helpers/constructSubmitData';

export const useHandleSubmit = ({
  inputs,
  setInputs,
  context,
}: IHandleSubmitParams): THandleSubmit => {
  return useCallback(
    submitCallback => {
      const validatedInputs = validateFormInputs(inputs, context);
      setInputs(validatedInputs);
      const isValid = !Object.values(validatedInputs).filter(input => input.errors?.length).length;
      if (isValid && submitCallback && isFunction(submitCallback)) {
        const data = constructSubmitData(validatedInputs);
        submitCallback(data);
      }
    },
    [inputs, context, setInputs]
  );
};
